<template>
  <div>
    <div class="row">
      <div class="col-md-2 pb-3 text-center">
        <h5>Schedule Reminders</h5>
      </div>
      <div class="col-md-3 pb-3">
        <b-input-group size="md">
          <b-input-group-text slot="append" class="bg-white">
            <strong>
              <i class="icon ion-md-search"  @click="onReminderSearchText"/>
            </strong>
          </b-input-group-text>
          <b-form-input
            class="border-right-0"
            :value="filter.searchValue"
            v-model="reminderSearchText"
            placeholder="Search by Careplan or ID"
            @keyup.enter.native="onReminderSearchText"
            
          />
        </b-input-group>
      </div>
      <div class="btn btn-link text-left" @click="resetFilters">
        <strong>
          <i class="ion-md-refresh mr-1" />
        </strong>Reset
      </div>
      <div class="col-md-6 text-right pb-3">
        <button class="btn btn-outline-primary" @click="scheduleReminder">
          <i class="icon ion-md-time" />
          Schedule Reminder
        </button>
      </div>
    </div>
    <div class="row">
      <template v-if="assessmentReminders && totalCount">
        <div
          class="col-lg-3 col-md-3 col-sm-6 p-2"
          v-for="reminder in assessmentReminders"
          :key="reminder.id"
        >
          <div class="card-inner-container" v-if="reminder.careplan">
            <div class="title">{{ reminder.careplan.title }}-{{ reminder.careplan.plan_no }}</div>
            <div class="footer row m-0 p-0">
              <div
                class="col col-12 p-0 text-left"
              >{{ reminder.careplan.patientCareplan.length }} Patients</div>
              <div
                class="col col-7 p-0 pt-3 text-left"
              >Created at: {{ defaultDateFormat(reminder.created_at) }}</div>
              <div
                class="col col-5 p-0 pt-3 text-right edit-reminder"
                @click="editReminder(reminder)"
                v-if="reminder.careplan && reminder.careplan.patientCareplan.length  <=0"
              >edit</div>
              <div
                class="col col-5 p-0 pt-3 text-right edit-reminder"
                @click="editReminder(reminder,'view')"
                v-else
              >View</div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <b-col class="text-center border">
          <span>No Data Found</span>
        </b-col>
      </template>
    </div>
    <table class="table">
      <thead></thead>
      <tbody />
      <TPagination
        v-if="totalCount"
        :columnLength="5"
        :count="totalCount"
        :rowsPerPage="filter.rowsPerPage"
        :page="filter.pageNo"
        :onChangePage="handleChangePage"
        :onChangeRowsPerPage="handleChangeRowsPerPage"
      />
    </table>
    <v-loader :isLoading="isLoading" />

    <b-modal
      id="modal-center"
      ref="assignCareplanRef"
      body-class="pt-0"
      size="md"
      centered
      title="Schedule Reminder"
    >
      <b-row>
        <b-col class="mt-2 carePlanCalendars">
          <b-row>
            <b-col>
              <label>Select Care Plan</label>
              <b-input-group size="lg">
                <b-form-input
                  v-model="carePlanSearchText"
                  type="text"
                  placeholder="Enter care plan name or ID"
                  class="search-bar"
                />
              </b-input-group>
              <div class="col col-md-12 col-12 mt-70">
                <div
                  v-if="(careplans &&
              !careplans.length || !careplans)
              && !careplanSearching"
                  class="d-flex justify-content-center"
                >No Data found</div>
                <div
                  v-for="careplan in careplans"
                  :key="careplan.id"
                  class="template"
                  @click="setCurrentCareplan(careplan)"
                >
                  <label v-restrict @click="viewCarePlan(careplan.id , true)">
                    <span class="btn-link">{{ careplan.title || ''}} - {{ careplan.plan_no}}</span>
                  </label>
                  <p v-if="careplan.plan_no"></p>
                  <div class="template-detail"></div>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
      id="modal-center"
      size="md"
      ref="planDurationRef"
      body-class="pt-0 reminders"
      centerer
      title="Set plan duration for patient"
    >
      <div class="row">
        <div
          class="col col-md-12 col-12 position-fixed pl-3 pr-3 search-bar-content pb-5 pt-2"
          v-if="selectedCareplan"
        >{{ selectedCareplan.title }} - {{ selectedCareplan.plan_no || '' }}</div>
        <div class="col col-md-12 col-12 mt-2 carePlanCalendars">
          <div class="mt-3 row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="input_type">Select Days</label>
                <b-form-select
                  v-model="reminder.days"
                  v-validate="'required'"
                  :disabled="this.disableReminder"
                  :multiple="true"
                  name="updated_at"
                  :options="plan_duration"
                ></b-form-select>
                <div
                  class="reminder-days"
                  v-if="reminder.days && reminder.days.length"
                >({{'D'+reminder.days.join(',D')}})</div>
              </div>
            </div>
            <div class="reminders-time-picker col-md-6">
              <v-time-picker
                @onChange="(value) => reminder.reminders = value"
                class="`form-group`"
                :label="`Time`"
                :disabled="this.disableReminder"
                full-width:true
                :className="{'danger': errors.has('Time') }"
                name="Time"
                allowEdit="false"
                :value="reminder.reminders"
                v-validate="'required'"
              />
            </div>
          </div>
        </div>
      </div>
      <div slot="modal-footer" class="w-100">
        <span
          v-if="isEditReminder"
          class="delete-reminder"
          @click="updateReminder('delete', reminder)"
        >
          <b-btn
            size="sm"
            class="button btn-danger"
            :disabled="this.disableReminder"
          >Delete Reminder</b-btn>
        </span>
        <span v-if="!this.disableReminder">
          <b-btn
            size="sm"
            class="float-right"
            variant="primary"
            v-if="isEditReminder"
            :disabled="this.isDisabled"
            @click="updateReminder('update',reminder)"
          >Update Reminder</b-btn>
          <b-btn
            size="sm"
            class="float-right"
            variant="primary"
            v-else
            :disabled="this.isDisabled"
            @click="addReminder"
          >Set Reminder</b-btn>
        </span>
        <b-btn
          size="sm"
          variant="outline-primary"
          class="float-right btn btn-outline-primary mr-2"
          @click="onAddReminderCancel"
        >Cancel</b-btn>
      </div>
    </b-modal>

    <v-loader :isLoading="isLoading" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VLoader from "@/components/loader/index.vue";
import careplan from "@/mixins/careplan";
import EVENTS from "@/constants/_events";
import TPagination from "@/components/table/pagination";

export default {
  data() {
    return {
      reminder: {
        total_days: null,
        days: [],
        is_active: true,
        reminders: "",
        careplan_id: "",
      },
      reminderSearchText:'',
      carePlanSearchText: '',
      isEditReminder: false,
      disableReminder: false,
      isDisabled: true,
      selectedCareplan: {},
      filter: {
        pageNo: 1,
        limit: 12,
        patient: "",
        careplan: "",
        searchValue: "",
        rowsPerPage: 12,
        day: "all"
      }
    };
  },
  watch: {
    filter: {
      handler: "fetchReminders",
      immediate: true
    },
    carePlanSearchText: {
      handler: "searchCarePlans",
      immediate: true
    },
    reminder: {
      handler: "validateBeforeSubmit",
      immediate: true,
      deep: true
    }
  },
  mounted() {
    this.$eventBus.$on(EVENTS.RELOAD_REMINDERS, () => this.fetchReminders());
  },
  components: {
    VLoader,
    TPagination
  },
  mixins: [careplan],
  methods: {
    onPageChange(pageNo, rowsPerPage) {
      this.tableProps.page = pageNo;
      this.filter = {
        ...this.filter,
        pageNo,
        limit: rowsPerPage
      };
    },
    fetchReminders() {
      this.$store.dispatch("reminders/getReminders", this.filter);
    },
    searchCarePlans(searchValue) {
      const filter = {
        ...this.filter,
        pageNo:'',
        searchValue
      };
      this.$store.dispatch("careplan/searchCarePlans", filter);
    },
    scheduleReminder() {
      this.$refs.assignCareplanRef.show();
    },
    handleChangePage(page) {
      if (!this.loading) {
        this.filter.pageNo = page;
        this.$store.dispatch("reminders/getReminders", this.filter);
      }
    },
    handleChangeRowsPerPage(event) {
      if (!this.loading) {
        const { page, onPageChange } = this.options;
        if (onPageChange) {
          onPageChange(page, event.target.value);
        }
      }
    },
    addReminder() {
      this.reminder.careplan_id = this.selectedCareplan.id;
      this.reminder.total_days = this.reminder.days.length;
      this.$store.dispatch("reminders/createReminder", this.reminder);
      // this.reminder = '';

      this.selectedCareplan = {};
      this.$refs.planDurationRef.hide();
      this.$refs.assignCareplanRef.hide();
    },
    onAddReminderCancel() {
      this.selectedCareplan = {};
      this.$refs.planDurationRef.hide();
    },
    onReminderSearchText() {
      this.filter = {
        ...this.filter,
        searchValue: this.reminderSearchText.toLowerCase()
      };
    },
    setCurrentCareplan(plan) {
      this.selectedCareplan = plan;
      this.reminder.days = [];
      this.reminder.reminders = "";
      this.isEditReminder = false;
      this.disableReminder = false;
      this.$refs.planDurationRef.show();
    },
    validateBeforeSubmit() {
      if (this.reminder.days.length && this.reminder.reminders) {
        this.isDisabled = false;
      } else {
        this.isDisabled = true;
      }
    },
    editReminder(reminder, type) {
      this.disableReminder = false;
      if (type === "view") {
        this.disableReminder = true;
      }
      if (reminder.id) {
        this.selectedCareplan.id = reminder.id;
      }

      if (reminder.careplan_id) {
        this.selectedCareplan.careplan_id = reminder.careplan_id;
      }

      this.selectedCareplan.title = reminder.careplan.title;
      this.selectedCareplan.plan_no = reminder.careplan.plan_no;
      this.reminder.days = reminder.days;
      this.reminder.reminders = reminder.reminders;
      this.isEditReminder = true;
      this.$refs.planDurationRef.show(this.selectedCareplan);
    },
    resetFilters() {
      this.filter = {
        pageNo: 1,
        limit: 12,
        patient: '',
        careplan: '',
        searchValue: '',
        rowsPerPage: 12,
        day: 'all'
      };
      this.reminderSearchText = '';
      this.reminderSearch = '';
    },
    viewCarePlan(id, isSelf) {
      const routeData = this.$router.resolve({
        name: "careplan.view",
        params: { id }
      });
      window.open(routeData.href, isSelf ? "_self" : "_blank");
    },
    updateReminder(type, reminder) {
      let content = {
        title: 'Update Reminder',
        message: 'Do you want to update this reminder?'
      };
      if (type === 'delete') {
        this.reminder.is_active = false;
        content = {
          title: 'Delete Reminder',
          message: 'Do you want to delete this reminder?'
        };
      }
      this.conFirmAlert(
        content,
        () => {
          // confirm
          const data = { ...reminder };
          data.careplan_id = this.selectedCareplan.careplan_id;
          data.id = this.selectedCareplan.id;
          this.$store.dispatch("reminders/updateReminder", data);
          this.selectedCareplan = {};
          this.isEditReminder = false;

          this.$refs.planDurationRef.hide();
          this.$refs.assignCareplanRef.hide();
        },
        () => {
          // cancel
        }
      );
    }
  },
  computed: {
    ...mapGetters({
      assessmentReminders: "reminders/getReminders",
      isLoading: "reminders/isReminderListLoading",
      careplans: "careplan/getSearchedCareplans",
      careplanSearching: "careplan/getSearching",
      totalCount: "reminders/getTotalCount"
    })
  }
};
</script>
<style lang="scss" scoped>
@import "./style.scss";
</style>
